module.exports = __webpack_public_path__ + "static/bbva-MONEI-fbfe411c79b775ed48935e85f76b27a9.png";